import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70d42e8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktoppage" }

import { computed } from 'vue';

import { useAppState, useGameState } from '@/services/composition';
import Viewport from '@/store/modules/Viewport';

import GLView from '@/components/GLView.vue';
import DesktopTuto from '@/components/DesktopTuto/DesktopTuto.vue';
import DesktopIntro from '@/components/DesktopIntro/DesktopIntro.vue';
import DesktopPause from '@/components/DesktopPause/DesktopPause.vue';
import DesktopEnding from '@/components/DesktopEnding/DesktopEnding.vue';
import DesktopOverlays from '@/components/DesktopOverlays/DesktopOverlays.vue';
import DesktopDebugView from '@/components/DesktopDebugView.vue';
import CustomCursor from '@/components/CustomCursor/CustomCursor.vue';
import UIPagePanel from "@/components/UIPagePanel/UIPagePanel.vue";
import type { pagePanelId } from "@/services/stores/page-panels";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()
const { state: appState, send } = useAppState();

const showOverlays = computed(() => {
  return ((state.value.matches('tuto') || state.value.matches('game')) && !state.value.context.isPaused) && !state.value.matches('end.failed')
})

const showCursor = computed(() => {
  return Viewport.isDesktop
})

const DEBUG = computed(() => {
  return !!(process.env.VUE_APP_DEBUG?.toLowerCase?.() === 'true' || process.env.VUE_APP_DEBUG === true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "long-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(GLView),
        (_unref(showOverlays))
          ? (_openBlock(), _createBlock(DesktopOverlays, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(state).matches('tuto') && !_unref(state).context.isPaused)
          ? (_openBlock(), _createBlock(DesktopTuto, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(_Transition, {
          name: "medium-fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_unref(state).context.isPaused)
              ? (_openBlock(), _createBlock(DesktopPause, { key: 0 }))
              : (_unref(state).matches('intro'))
                ? (_openBlock(), _createBlock(DesktopIntro, { key: 1 }))
                : (_unref(state).matches('end'))
                  ? (_openBlock(), _createBlock(DesktopEnding, { key: 2 }))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_unref(appState).context.pagePanelId)
          ? (_openBlock(), _createBlock(UIPagePanel, {
              key: _unref(appState).context.pagePanelId,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)({ type: 'SET_PAGE_PANEL', id: null }))),
              onRedirect: _cache[1] || (_cache[1] = (slug) => _unref(send)({ type: 'SET_PAGE_PANEL', id: slug }))
            }))
          : _createCommentVNode("", true),
        (_unref(showCursor))
          ? (_openBlock(), _createBlock(CustomCursor, { key: 3 }))
          : _createCommentVNode("", true),
        (_unref(DEBUG))
          ? (_openBlock(), _createBlock(DesktopDebugView, {
              key: 4,
              class: "debug"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})